"use client";

import { ILeadDropPopup } from "@/api/admin/leadDropPopup";
import { Dialog, DialogContent } from "@/components/atoms/Dialog";
import { cn } from "@/lib/utils";
import { CLOSE_BTN_CATEGORY } from "@/types/common";
import React from "react";
import LeaddropDelay5026 from "./LeaddropDelay5026";

interface LeaddropDelay5026DialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onClose?: () => void;
  formData?: ILeadDropPopup | null;
  courses?: unknown[];
  qualification?: unknown[];
}

/**
 * The dialog shell for Lead Drop Delay Form 5026.
 *
 * v1 sizes this one `max-w-96 md:max-w-lg` — narrower than the lead drop it
 * hands off to, because it is a single column of fields with no image beside it.
 */
const LeaddropDelay5026Dialog = ({
  open,
  onOpenChange,
  onClose,
  formData,
  courses,
  qualification,
}: LeaddropDelay5026DialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        // The card draws its own close button, as v1's does.
        closeBtnType={CLOSE_BTN_CATEGORY.PROMOTIONAL_POPUP}
        className={cn(
          "border-0 bg-transparent p-0 shadow-none",
          "max-h-[95dvh] overflow-y-auto",
          "w-[90%] max-w-96 tab:max-w-lg",
        )}
        dialogOverlayStyle={cn("bg-black/50")}
      >
        <LeaddropDelay5026
          formData={formData}
          courses={courses}
          qualification={qualification}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default LeaddropDelay5026Dialog;
